import { domainError, err, ok } from '@flourprint/core/domain';
/**
 * Restores into memory stores atomically: every check runs first, then every write happens
 * synchronously, so a failure leaves both stores untouched.
 */
export class MemoryRestoreTarget {
    recipes;
    bakes;
    flours;
    equipment;
    ingredients;
    constructor(recipes, bakes, flours, equipment, ingredients) {
        this.recipes = recipes;
        this.bakes = bakes;
        this.flours = flours;
        this.equipment = equipment;
        this.ingredients = ingredients;
    }
    async restore(plan) {
        if (!this.recipes.isEmpty ||
            !this.bakes.isEmpty ||
            !this.flours.isEmpty ||
            !this.equipment.isEmpty ||
            !this.ingredients.isEmpty) {
            return err(domainError('TargetNotEmpty', 'Backups are restored into an empty database', undefined));
        }
        const eventIds = new Set();
        for (const bake of plan.bakes) {
            this.bakes.check(bake);
            for (const event of bake.events) {
                if (eventIds.has(event.eventId))
                    throw new Error(`Duplicate event id ${event.eventId}`);
                eventIds.add(event.eventId);
            }
        }
        for (const family of plan.families)
            this.recipes.writeFamily(family);
        for (const recipe of plan.recipes)
            this.recipes.write(recipe);
        for (const draft of plan.drafts ?? [])
            this.recipes.restoreDraft(draft);
        for (const entry of plan.flours ?? [])
            this.flours.write(entry);
        for (const entry of plan.equipment ?? [])
            this.equipment.write(entry);
        for (const entry of plan.ingredients ?? [])
            this.ingredients.write(entry);
        for (const bake of plan.bakes)
            this.bakes.write(bake);
        return ok(undefined);
    }
}
//# sourceMappingURL=restore-target.js.map